import React from 'react';
import "./DadosAvulsos.css";

function DadosAvulsos({ dados }) {

    const { titulo1, titulo2, mesAno, vendedorCom, vpTotal } = dados;
    const { totalComissao, totalVendas } = vendedorCom;
    const { mes, ano } = mesAno;

    function formatarNomeMes(numeroMes) {
        const mes = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];

        return mes[numeroMes - 1];
    }

    function formatarMoeda(valor) {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    function formatarPercentual(valor) {
        const percentualFormatado = valor.replace('.', ',');
        return`${percentualFormatado.toLocaleString('pt-BR')}%`;
    }

    function verificaObjetoVazio(objeto) {
        return Object.keys(objeto).length === 0;
    }

    return (
        <div style={{ padding: '0% 30% 0% 20%' }}>

            <div className='card-header-avulsos font-titulo-avulsos' style={{ marginBottom: '0px' }}>
                <h4 className='uppercase'>{titulo1}</h4>
                <span className='text-[10px]' style={{ color: '#888888' }}>{formatarNomeMes(1)} de {ano} até {formatarNomeMes(mes)} de {ano}</span>
            </div>
            <p className='font-body-avulsos'>Meta: <strong>{verificaObjetoVazio(vpTotal) ? '00,00' : formatarMoeda(vpTotal[0].meta)}</strong></p>
            <p className='font-body-avulsos'>Real: <strong>{verificaObjetoVazio(vpTotal) ? '00,00' : formatarMoeda(vpTotal[0].realizado)}</strong></p>
            <p className='font-body-avulsos'>Atendimentos: <strong>{verificaObjetoVazio(vpTotal) ? '00,00' : formatarPercentual(vpTotal[0].percentualrealizado)}</strong></p>

            <div className='borda-avulsos'></div>
            
            <div className='card-header-avulsos font-titulo-avulsos'>
                <h4 className='uppercase'>{titulo2}</h4>
                <span className='text-[10px]' style={{ color: '#888888' }}>{formatarNomeMes(mes)} {ano}</span>
            </div>
            <p className='font-body-avulsos'>Total de pedidos: <strong>{totalVendas > 0 ? formatarMoeda(totalVendas) : '00,00'}</strong></p>
            <p className='font-body-avulsos'>Total de comissões: <strong>{totalComissao > 0 ? formatarMoeda(totalComissao) : '00,00'}</strong></p>
        </div>
    );
}

export default DadosAvulsos